import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import {
  SUPPORTED_LANGUAGE_CODES,
  normalizeLanguageCode,
} from "./constants/supportedLanguages";

const storedLng =
  typeof window !== "undefined"
    ? normalizeLanguageCode(window.localStorage.getItem("preferredLanguage"))
    : null;

// Bump when locale JSON changes so browsers do not keep stale translation.json
const LOCALE_CACHE_BUSTER = "2026-08-24-1";

i18n
  .use(
    new Backend(null, {
      // Locale JSON lives in public/app/locales. Live is mounted at /app, so this
      // path is /app/locales/... on both sandbox (shared origin) and live.
      loadPath: `/app/locales/{{lng}}/{{ns}}.json?v=${LOCALE_CACHE_BUSTER}`,
    })
  )
  .use(initReactI18next)
  .init({
    lng: storedLng || "da",
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    nonExplicitSupportedLngs: true,
    // Map fr-FR → fr so locale files load (404s were breaking namespaces)
    load: "languageOnly",
    // Missing keys fall back to Danish, then English — do not start in English.
    fallbackLng: ["da", "en"],
    // Load meeting on demand; a 404 on meeting.json must not block translation.
    ns: ["translation"],
    defaultNS: "translation",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      // Prevent useTranslation() from suspending during language loads.
      // Without this, switching languages causes React to "replay" the entire
      // component from scratch, resetting all useState back to initial values.
      useSuspense: false,
      // Default bindI18n is only "languageChanged" — components never re-render
      // after the HTTP backend loads translation.json, so keys like LP_HERO_* stay
      // visible while keys that match English (e.g. "Platform") look fine.
      bindI18n: "languageChanged loaded",
      bindI18nStore: "added removed",
    },
  });

export default i18n;
